module.exports = __webpack_public_path__ + "static/media/kitchen.ca19d824.png";